import { useQuery } from '@tanstack/react-query';
import { procurementService } from '../../services/procurement.service';
import { queryKeys } from '../../lib/query-keys';

export function useMaterialRequisitions(orgId: string | null) {
  return useQuery({
    queryKey: queryKeys.requisitions.all(orgId ?? ''),
    queryFn: () => procurementService.getMaterialRequisitions(orgId!),
    enabled: !!orgId,
    staleTime: 30_000,
  });
}

export function useRequisitionItems(requisitionId: string | null) {
  return useQuery({
    queryKey: queryKeys.requisitions.items(requisitionId ?? ''),
    queryFn: () => procurementService.getRequisitionItems(requisitionId!),
    enabled: !!requisitionId,
    staleTime: 30_000,
  });
}
